import {Input, DatePicker} from 'antd-mobile';
import {InputNumber} from './InputNumber'
import { SelectPicker } from './SelectPicker';
import { CopyIconInput } from './CopyIcon';
import { Current } from './Current';
import { BalanceVB } from './BalanceVB';
import { CurrentVB } from './CurrentVB';

export const enum FIELD_TYPE{
  INPUT= '1',
  Number = '2',
  SELECT = '3',
  DATE = '4',
  CopyIcon = 'CopyIcon',
  Current = 'Current',
  BalanceVB = 'BalanceVB',
  CurrentVB = 'CurrentVB',
}

export const FIELD_TYPE_MAP: Record<string, any> = {
  [FIELD_TYPE.INPUT]: Input,
  [FIELD_TYPE.SELECT]: SelectPicker,
  [FIELD_TYPE.Number]: InputNumber,
  [FIELD_TYPE.DATE]: DatePicker,
  [FIELD_TYPE.CopyIcon]: CopyIconInput,
  [FIELD_TYPE.Current]: Current,
  [FIELD_TYPE.BalanceVB]: BalanceVB,
  [FIELD_TYPE.CurrentVB]: CurrentVB,
}